export const DARK_PURPLE_BG = "bg-[#010021]";
export const DARK_PURPLE_THEME_COLOR = "#010021";

export const LIGHT_PURPLE_THEME_COLOR = "#CDCBFF";
